import { Injectable } from '@angular/core';
import { MatSnackBar , MatSnackBarConfig  } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { BroadcastService } from './broadcast.service';

@Injectable({
  providedIn: 'root'
})

export class NotificationService {
  isSessionAutoLogoffTimerOpen = false;
  constructor(public snackBar: MatSnackBar, private router: Router, private broadcastService: BroadcastService) { }

  config: MatSnackBarConfig = {
    duration: 3000,
    horizontalPosition: 'center',
    verticalPosition: 'bottom'
  };

  configPush: MatSnackBarConfig = {
    duration: undefined,
    horizontalPosition: 'center',
    verticalPosition: 'bottom'
  };

  configPushSuccess: MatSnackBarConfig = {
    duration: 5000,
    horizontalPosition: 'center',
    verticalPosition: 'bottom'
  };

  configSessionManagement: MatSnackBarConfig = {
    duration: undefined,
    horizontalPosition: 'center',
    verticalPosition: 'bottom',
    panelClass: ['full-width-snackbar']
  };

  getSnackBar() {
    return this.snackBar;
  }

  dismissSnackbar() {
    this.snackBar.dismiss();
  }

  dismissSnackbarWithMessage(message: string) {
    if (this.snackBar._openedSnackBarRef
      && this.snackBar._openedSnackBarRef.instance.data.message.indexOf(message) >= 0) {
      this.snackBar.dismiss();
    }
  }

  success(msg) {
    // tslint:disable-next-line: no-string-literal
    this.config['panelClass'] = ['notification', 'success'];
    this.snackBar.open(msg, '', this.config);
  }

  warn(msg, time?: number) {
    // tslint:disable-next-line: no-string-literal
    this.config['panelClass'] = ['notification', 'warn'];
    this.config.duration = (time) ? time : 3000;
    this.snackBar.open(msg, '', this.config);
  }

  info(msg, action?: string, options?: object) {
    this.configPush = { ...this.configPush, ...options };
    // tslint:disable-next-line: no-string-literal
    this.configPush['panelClass'] = ['notification', 'info'];
    this.snackBar.open(msg, (action) ? action : '', this.configPush);
  }

  sessionWarning(msg, action?: string, options?: object) {
    // tslint:disable-next-line: no-string-literal
    this.configSessionManagement = { ...this.configSessionManagement, ...options };
    return this.snackBar.open(msg, (action) ? action : '', this.configSessionManagement);
  }

  successPush(msg) {
    // tslint:disable-next-line: no-string-literal
    this.configPushSuccess['panelClass'] = ['notification', 'success'];
    this.snackBar.open(msg, '', this.configPushSuccess);
  }

  openAction(msg, action: string, routeUrl: string, time?: number) {

    // tslint:disable-next-line: no-string-literal
    this.config['panelClass'] = ['notification', 'warn'];
    this.config.duration = (time) ? time : 15000;
    const snackbarRef = this.snackBar.open(msg, action, this.config);
    snackbarRef.onAction()
        .subscribe(() => {
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => this.router.navigate([routeUrl]));
          setTimeout(() => {
            this.broadcastService.broadcast('notificationWithAction', true);
          }, 0);
      });
  }

  sessionWarningAutoLogoff(msg, action?: string, options?: object) {
    // tslint:disable-next-line: no-string-literal
    this.isSessionAutoLogoffTimerOpen = true;
    this.configSessionManagement = { ...this.configSessionManagement, ...options };
    return this.snackBar.open(msg, (action) ? action : '', this.configSessionManagement);
  }

  sessionWarningAutoLogoffDismiss(){
    if(this.isSessionAutoLogoffTimerOpen){
      this.isSessionAutoLogoffTimerOpen = false;
      this.snackBar.dismiss();
    }
  }
}
